// app/javascript/controllers/source_select_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "error", "topSubmit", "submit"]

  connect() {
    this.validateInitialState()
  }

  validateInitialState() {
    const name = (this.hasNameTarget ? this.nameTarget.value : "").trim()
    const rb = this.element.querySelector("input[type='radio'][name='source[kind]']:checked")
    const hasKindRadios = this.element.querySelector("input[type='radio'][name='source[kind]']") !== null

    // For new sources we require a selected kind radio.
    // For existing sources (no kind radios rendered) we only require a valid name.
    if (name.length >= 3 && (!hasKindRadios || rb)) {
      // form is ready → show submit button
      this.clearError()
      this.showTopSubmit()
    } else {
      this.hideTopSubmit()
    }
  }

  // data-action="change->source-select#submitViaRadio"
  submitViaRadio(event) {
    const rb = event.target
    const form = rb.closest("form")
    const name = (this.nameTarget?.value || "").trim()
    if (name.length < 3) {
      this.showError("Enter a proper name for your source first. ( at least 3 characters long)")
      this.nameTarget?.setAttribute("aria-invalid", "true")
      this.nameTarget?.focus({ preventScroll: true })
      this.nameTarget?.scrollIntoView({ behavior: "smooth", block: "center" })
      this.showTopSubmit()
      return
    }

    // clear error and submit (next tick so the radio value is included)
    this.clearError()
    this.hideTopSubmit()
       setTimeout(() => {
      if (this.hasSubmitTarget) {
        // ✅ click the first *enabled/visible* submit button
        const btn = this.submitTargets.find(el => !el.classList.contains("hidden") && !el.disabled)
        if (btn) {
          btn.click()
        } else {
          form?.requestSubmit()
        }
      } else {
        form?.requestSubmit()
      }
    }, 0)
  }

    submitViaTop(event) {
    event.preventDefault()
    const form = event.target.closest("form")
    const name = (this.nameTarget?.value || "").trim()

    if (name.length < 3) {
      this.showError("Enter a name (3+ characters) before continuing.")
      return
    }

    this.clearError()
    if (form?.requestSubmit) form.requestSubmit()
    else form?.submit()
  }

  clearError() {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = ""
      this.errorTarget.classList.add("hidden")
    }
    if (this.hasNameTarget) this.nameTarget.removeAttribute("aria-invalid")
  }

  showError(msg) {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = msg
      this.errorTarget.classList.remove("hidden")
    }
  }

  showTopSubmit() {
    if (this.hasTopSubmitTarget) this.topSubmitTarget.classList.remove("hidden")
  }

  hideTopSubmit() {
    if (this.hasTopSubmitTarget) this.topSubmitTarget.classList.add("hidden")
  }


}
